const v ={
    bloopScale: 'scale(1.1)',
};
export default v;
